import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { theme, cardStyle, inputStyle, btnStyle, labelStyle, tdStyle, thStyle } from '../theme';

const DAYS = [
  { key: 'mon', label: 'Monday' },
  { key: 'tue', label: 'Tuesday' },
  { key: 'wed', label: 'Wednesday' },
  { key: 'thu', label: 'Thursday' },
  { key: 'fri', label: 'Friday' },
  { key: 'sat', label: 'Saturday' },
  { key: 'sun', label: 'Sunday' },
];

const DEFAULT_HOURS = {
  sun: { open: '',      close: '',      isClosed: true  },
  mon: { open: '09:00', close: '20:00', isClosed: false },
  tue: { open: '09:00', close: '20:00', isClosed: false },
  wed: { open: '09:00', close: '20:00', isClosed: false },
  thu: { open: '09:00', close: '20:00', isClosed: false },
  fri: { open: '09:00', close: '20:00', isClosed: false },
  sat: { open: '09:00', close: '14:00', isClosed: false },
};

const BranchMasterPage = ({ API_BASE, refreshBranches }) => {
  const [branches, setBranches] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm());

  function emptyForm() {
    return {
      name:'', code:'', address:'', city:'', state:'', pincode:'', phone:'', email:'', gstin:'',
      hours: JSON.parse(JSON.stringify(DEFAULT_HOURS)),
    };
  }

  const fetchBranches = async () => {
    try { const r = await axios.get(`${API_BASE}/branches`); setBranches(r.data); } catch (e) {}
  };

  useEffect(() => { fetchBranches(); }, []); // eslint-disable-line

  const handleSave = async () => {
    if (!form.name.trim()) return alert('Branch name is required');
    try {
      if (editing) await axios.put(`${API_BASE}/branches/${editing._id}`, form);
      else         await axios.post(`${API_BASE}/branches`, form);
      setForm(emptyForm()); setEditing(null);
      fetchBranches();
      refreshBranches && refreshBranches();
    } catch (e) { alert(e.response?.data?.error || 'Save failed'); }
  };

  const handleEdit = (b) => {
    setEditing(b);
    const mergedHours = { ...DEFAULT_HOURS };
    DAYS.forEach(d => {
      const src = b.hours?.[d.key] || {};
      mergedHours[d.key] = {
        open: src.open || '',
        close: src.close || '',
        isClosed: typeof src.isClosed === 'boolean'
          ? src.isClosed
          : !(src.open && src.close), // fall-back for rows that pre-date the isClosed flag
      };
    });
    setForm({
      name:b.name||'', code:b.code||'', address:b.address||'', city:b.city||'',
      state:b.state||'', pincode:b.pincode||'', phone:b.phone||'', email:b.email||'', gstin:b.gstin||'',
      hours: mergedHours,
    });
  };

  const handleSetPrimary = async (id) => {
    await axios.put(`${API_BASE}/branches/${id}/set-primary`);
    fetchBranches();
    refreshBranches && refreshBranches();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Deactivate this branch?')) return;
    await axios.delete(`${API_BASE}/branches/${id}`);
    fetchBranches();
    refreshBranches && refreshBranches();
  };

  const handleCancel = () => { setEditing(null); setForm(emptyForm()); };

  return (
    <div style={cardStyle}>
      <h3 style={{color:theme.navy, margin:'0 0 14px'}}>🏢 Branches</h3>

      <div style={{backgroundColor:'#f8f9fa', borderRadius:'10px', padding:'18px', marginBottom:'20px'}}>
        <h4 style={{color:'#0582ca', margin:'0 0 14px'}}>{editing ? 'Edit Branch' : '+ Add New Branch'}</h4>
        <div style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr', gap:'12px', marginBottom:'12px'}}>
          <div><label style={labelStyle}>Name *</label><input value={form.name} onChange={e=>setForm({...form, name:e.target.value})} style={inputStyle}/></div>
          <div><label style={labelStyle}>Short Code</label><input value={form.code} onChange={e=>setForm({...form, code:e.target.value})} placeholder="MJM" style={inputStyle}/></div>
          <div><label style={labelStyle}>GSTIN</label><input value={form.gstin} onChange={e=>setForm({...form, gstin:e.target.value})} style={inputStyle}/></div>
          <div style={{gridColumn:'span 3'}}><label style={labelStyle}>Address</label><input value={form.address} onChange={e=>setForm({...form, address:e.target.value})} style={inputStyle}/></div>
          <div><label style={labelStyle}>City</label><input value={form.city} onChange={e=>setForm({...form, city:e.target.value})} style={inputStyle}/></div>
          <div><label style={labelStyle}>State</label><input value={form.state} onChange={e=>setForm({...form, state:e.target.value})} style={inputStyle}/></div>
          <div><label style={labelStyle}>Pincode</label><input value={form.pincode} onChange={e=>setForm({...form, pincode:e.target.value})} style={inputStyle}/></div>
          <div><label style={labelStyle}>Phone</label><input value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})} style={inputStyle}/></div>
          <div style={{gridColumn:'span 2'}}><label style={labelStyle}>Email</label><input value={form.email} onChange={e=>setForm({...form, email:e.target.value})} style={inputStyle}/></div>
        </div>

        <div style={{fontSize:'0.78rem', color:'#6c757d', marginBottom:12, padding:'8px 12px', background:'#f0f6fb', borderRadius:8}}>
          🕘 Clinic opening hours <strong>Settings → Calendar Settings</strong> me set karein — waha se online booking gate hota hai.
        </div>

        <div style={{display:'flex', gap:'10px'}}>
          <button onClick={handleSave} style={{...btnStyle, marginTop:0}}>{editing ? 'Update' : 'Add Branch'}</button>
          {editing && <button onClick={handleCancel} style={{...btnStyle, marginTop:0, backgroundColor:'#6c757d'}}>Cancel</button>}
        </div>
      </div>

      <table style={{width:'100%', borderCollapse:'collapse'}}>
        <thead>
          <tr>
            <th style={thStyle}>Name</th>
            <th style={thStyle}>Code</th>
            <th style={thStyle}>City</th>
            <th style={thStyle}>Phone</th>
            <th style={thStyle}>Hours</th>
            <th style={thStyle}>Status</th>
            <th style={thStyle}></th>
          </tr>
        </thead>
        <tbody>
          {branches.map(b => (
            <tr key={b._id}>
              <td style={tdStyle}>
                <strong>{b.name}</strong>
                {b.isPrimary && <span style={{marginLeft:'8px', padding:'2px 8px', borderRadius:'10px', fontSize:'0.7rem', fontWeight:'700', backgroundColor:theme.primaryLight, color:theme.primaryDark}}>PRIMARY</span>}
              </td>
              <td style={tdStyle}>{b.code || '—'}</td>
              <td style={tdStyle}>{b.city || '—'}</td>
              <td style={tdStyle}>{b.phone || '—'}</td>
              <td style={{...tdStyle, fontSize:'0.74rem', color:'#6c757d', lineHeight:1.4}}>
                {(() => {
                  const h = b.hours || {};
                  const openDays = DAYS.filter(d => !h[d.key]?.isClosed && h[d.key]?.open && h[d.key]?.close);
                  if (!openDays.length) return 'Not set';
                  // Summarise: if all open days share the same window, show one range.
                  const ranges = {};
                  openDays.forEach(d => {
                    const k = `${h[d.key].open}-${h[d.key].close}`;
                    (ranges[k] = ranges[k] || []).push(d.label.slice(0,3));
                  });
                  return Object.entries(ranges).map(([rng, ds]) =>
                    <div key={rng}>{ds.join(', ')} &nbsp;<strong>{rng}</strong></div>
                  );
                })()}
              </td>
              <td style={tdStyle}>
                <span style={{padding:'3px 10px', borderRadius:'12px', fontSize:'0.74rem', fontWeight:'700',
                  backgroundColor: b.isActive ? '#d1fae5' : '#fee2e2',
                  color: b.isActive ? '#065f46' : '#991b1b'}}>
                  {b.isActive ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td style={tdStyle}>
                <button onClick={()=>handleEdit(b)} style={{padding:'5px 12px', backgroundColor:'#0582ca', color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'0.78rem', fontWeight:'600', marginRight:'6px'}}>Edit</button>
                {!b.isPrimary && <button onClick={()=>handleSetPrimary(b._id)} style={{padding:'5px 12px', backgroundColor:theme.primary, color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'0.78rem', fontWeight:'600', marginRight:'6px'}}>Set Primary</button>}
                {b.isActive && <button onClick={()=>handleDelete(b._id)} style={{padding:'5px 12px', backgroundColor:theme.danger, color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'0.78rem', fontWeight:'600'}}>Deactivate</button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BranchMasterPage;
